import { create } from "zustand";

type Studio = {
  id: string;
  slug: string;
  name: string;
  timezone: string;
  currency: string;
  defaultLocale: string;
};

export type WidgetState = {
  studioId: string | null;
  studio: Studio | null;
  status: "idle" | "loading" | "ready" | "error";
  error?: string;

  setStudioId: (id: string) => void;
  loadStudio: (id?: string) => Promise<void>;
};

export const useStudioStore = create<WidgetState>((set, get) => ({
  studioId: null,
  studio: null,
  status: "idle",

  setStudioId: (id) =>
    set({
      studioId: id,
      status: "loading",
      error: undefined,
    }),

  loadStudio: async (id?: string) => {
    const studioId = id ?? get().studioId;
    if (!studioId) return;

    set({ status: "loading" });

    try {
      const res = await fetch(`/api/widget/public/studios/${studioId}`);

      if (!res.ok) {
        throw new Error("Studio not found");
      }

      const data = await res.json();

      set({
        studio: data.studio,
        status: "ready",
      });
    } catch (err) {
      set({
        status: "error",
        error: "Invalid or inactive studio",
      });
    }
  },
}));
